import Model from "~/models/_Model";
import User from "./User";
import Permission from "./Permission";

export default class Role extends Model {
  // Set the resource route of the model
  resource() {
    return "roles";
  }

  relations() {
    return {
      users: User,
      permissions: Permission,
    };
  }

  get display_display_name() {
    return `${this.display_name} (${this.id}:${this.name})`;
  }
}
